// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"465":"6021f181","1191":"8dfb93a4","5623":"7700f507","5794":"7e747f56","6910":"15ffcafa"}[chunkId] + ".chunk.css";
};